import React from "react";
import House from "../../img/house.svg";
import Invoice from "../../img/invoice.svg";
import Owner from "../../img/owner.svg";

export enum LabelType {
  personal = "personal",
  official = "official",
  email = "email",
  website = "website",
}

interface CardData {
  labelType: LabelType;
  label?: string;
}

export enum InfoCardType {
  Account = "Account",
  Billing = "Billing",
  Ownership = "Ownership",
}

interface CardProps {
  cardTitle: string;
  cardType: InfoCardType;
  details: CardData[];
}

export const InfoCard: React.FC<CardProps> = ({
  cardType,
  details,
  cardTitle,
}) => (
  <div
    className={`infoCard flex-grow-1 ${cardType == InfoCardType.Account && "primary-light-bg"}`}
  >
    <p>
      {cardType == InfoCardType.Account
        ? "Account Rep: "
        : cardType == InfoCardType.Billing
          ? "Invoicing / BIlling: "
          : "Ownership:"}{" "}
      <strong>{cardTitle}</strong>
    </p>
    {details.map((detail, index) => (
      <div
        key={`${cardType} - ${index}`}
        className={`infoCard-${detail.labelType}`}
      >
        {detail.label}
      </div>
    ))}
    <div className="infoCardImg">
      {cardType == InfoCardType.Account ? (
        <img src={House} alt="Account Icon" height="70" width="70" />
      ) : cardType == InfoCardType.Billing ? (
        <img src={Invoice} alt="Invoice Icon" height="70" width="70" />
      ) : (
        <img src={Owner} alt="Ownership Icon" />
      )}
    </div>
  </div>
);
